const toggle = () => {
  const triggers = document.querySelectorAll('.js-faq-trigger');

  triggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      const parent = trigger.closest('.js-faq-item');
      parent.classList.toggle('is-open');
    });

  });
};

const main = () => {
  toggle();
};

export default main;
